import Api from "@/services/api"; // Assuming your API class is in /services/api.js

const api = new Api();

export default {
    install: (app) => {
        app.config.globalProperties.$api = api;
    },
};

export { api };
